import React from 'react';
import './documentCategories.scss';

import {handleAuthError, useCheckUserAuthentication,fetchLookup} from '../../globals';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Editing,
  Selection,
  SearchPanel,
  Lookup
} from 'devextreme-react/data-grid';

import { useState, useEffect } from "react";

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/DocumentoCategoria'

const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/GetAction',
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction',

    errorHandler: (error) => {
      handleAuthError(error);
    }
         
});

export default function DocumentCategories() {
  
  const [ruoli, setRuoli] = useState({});

  const user = useCheckUserAuthentication();

  useEffect(() => {
    
    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Roles';
    var newUrl1 =  newServiceUrl1 + "/GetAction";


    const fetchData = async () => {

      if (!user?.token) {
        return;
      }

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const json1 = await fetchLookup(newUrl1,requestOptions);
        if (json1) {
          setRuoli(json1);
        }

      } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
  }, [user?.token]); // Aggiorna se il token cambia

  function onEditorPreparing(e) {
    if(e.dataField === "roleId" && e.parentType ==="dataRow") {
      e.editorOptions.showClearButton = true;
    }
  }

  return(

    
    <React.Fragment>
      <h2 className={'content-block'}>Categorie Documento</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
        <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          onEditorPreparing={onEditorPreparing}
        >
          
          <SearchPanel visible={true} width={240} placeholder="Cerca..." />
          <Selection mode="single" />
          <Editing
            mode="row"
            useIcons={true}
            allowAdding={true}
            allowDeleting={true}
            allowUpdating={true}     
          />
          <Column dataField="id" visible={false}/>
          <Column dataField="nome" />
          <Column dataField="roleId" caption="Ruolo Responsabile" visible={true}>
            <Lookup dataSource={ruoli} valueExpr="id" displayExpr="name" />
          </Column>
      
        </DataGrid>  
        </div>
      </div>
    </React.Fragment>
  )
};

